import type { FaireProductEntity } from "../../entity_types/product";

export const p_tq9zdg8vd8: FaireProductEntity = {
  token: "p_tq9zdg8vd8",
  type: "product",
  name: "Kantha Boho Long Skirt with Pockets",
  brandToken: "b_7rkbvdp47b",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/4c51d15d742ee829d888400c7b4561d01abd4536fe2df67eaf5901d3f0425585.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ac8d6297f8213ed0296f7351e5777988a84b684a9949daefe0825e59f04d391b.jpeg",
    "https://cdn.faire.com/fastly/8e5854649e7cad9481494ed2951690a2ebbd2142e21bec8fa2a526a97bdfa67d.jpeg",
    "https://cdn.faire.com/fastly/51365c4d0b832fd0e6fd4d202aa2f4ed67e4d4c0029b5871a5c663b2638fed49.jpeg",
    "https://cdn.faire.com/fastly/1fe3857465a55824cfb85fbfe739b89fa07bdbdf6a5930f1e26a11ceb2718b59.jpeg",
    "https://cdn.faire.com/fastly/469498f0c15bb0816118bc50f430460c9d07013995d0884894c4d75f61624a04.jpeg",
    "https://cdn.faire.com/fastly/13b9775dfe3a544dd69dad1aa1cbca386040208bf692f65eb1802fd2829d2076.jpeg",
    "https://cdn.faire.com/fastly/ff4379e1dbcb8a72a540e7c48c162df28eb2d81d2de2e9073ffc0007b365ac43.jpeg",
    "https://cdn.faire.com/fastly/5642c39e6d3a6cd652cce0e5858fd750d3656fa90378a90881077f293d98e7d0.jpeg",
  ],
  priceDollars: 44.34,
  description:
    "The Kantha Flowy Long Skirt with Pockets is a handmade, tiered skirt made of upcycled, sustainable kantha fabric. Its flowy design and practical pockets make it perfect for any season, while its bohemian hippie and gypsy style adds a touch of unique fashion to any wardrobe.\n\nHandmade in Nepal\nMaterial: Upcycled Cotton, Kantha\n**Elastic Waist with a Drawstring to adjust\n**Two Side Pockets\nSize: One Size; Fits up to US Size Large\n\n\nLength: Approx.  41 inches\nWaist: Fits up to Approx. 44 inches",
  tags: [],
  msrpDollars: 88.68,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:34.736Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
